export const selectors = {
  // States
  hover: '&:hover',
  focus: "&:focus-visible, &:has(:focus-visible), &[data-focus-visible='true']",
  interactive: '&:hover, &:focus-visible, &:has(:focus-visible), &[data-focus-visible="true"]',
  all: '&, &:hover, &:focus-visible, &:has(:focus-visible), &[data-focus-visible="true"]',

  // Browsers
  safari: `@supports (font: -apple-system-body) and (-webkit-appearance: none)`,
};
